import { selectBasketSelectedWarehouses } from 'containers/OrderDetails/basketSlice'
import React, { useEffect, useState } from 'react'
import useShopParams from './useShopParams'
import { shopproducts } from 'rest/urls'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { POST } from 'rest/request'

interface SelectedWarehouse {
  placeId: string
  cartId: string
  hash: string
  id?: string
}

type Data = shop.ProductsCategory

const useShopData = (
  selectCategoryKey?: React.Dispatch<React.SetStateAction<string>>
) => {
  const { cartId, warehouseId, equipmentId } = useShopParams()
  const selectedWarehouses = useReduxSelector(selectBasketSelectedWarehouses)
  const [data, setData] = useState<Data[] | null>(null)
  const [isLoading, setLoading] = useState(false)
  const config = useReduxSelector(selectConfig)

  const fetchMagDetails = async (body: object | undefined, equipmentId?: string, callback?: (_: string) => void) => {
    setLoading(true)
    try {
      const url = equipmentId ? `${shopproducts}/${equipmentId}` : shopproducts
      const response = await POST(url, { body })
      if (Array.isArray(response)) {
        setData(response)
        callback?.(response?.[0]?.id)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const prepareBody = (_selectedWarehouses: SelectedWarehouse[], _config?: app.Config, _cartId?: string, _warehouseId?: string) => {
    const selectedWarehouse = (_cartId && _selectedWarehouses.length > 0)
      ? _selectedWarehouses.find(w => w.cartId === _cartId)
      : undefined
    const source = _config?.rentalUpsellEnabled && _config?.storeEnabled
      ? 'all'
      : _config?.rentalUpsellEnabled
        ? 'rental'
        : undefined

    if (selectedWarehouse?.id || _warehouseId) {
      return {
        related: {
          object: 'Warehouse',
          id: selectedWarehouse?.id || _warehouseId
        },
        source
      }
    }

    if (selectedWarehouse) {
      return {
        related: {
          object: 'Warehouse',
          hash: selectedWarehouse.hash,
          placeId: selectedWarehouse.placeId,
        },
        source
      }
    }
  }

  useEffect(() => {
    const body = prepareBody(selectedWarehouses, equipmentId ? undefined : config, cartId, warehouseId)
    fetchMagDetails(body, equipmentId, selectCategoryKey)
  }, [cartId, config, warehouseId, equipmentId, selectedWarehouses, selectCategoryKey])

  return {
    data,
    isLoading
  }
}

export default useShopData